// extracted by mini-css-extract-plugin
export default {"title":"style_title__f70nv","subtitle":"style_subtitle__YLshe"};